import { render, staticRenderFns } from "./div-tab.vue?vue&type=template&id=6b93c02c&scoped=true"
import script from "./div-tab.vue?vue&type=script&lang=js"
export * from "./div-tab.vue?vue&type=script&lang=js"
import style0 from "./div-tab.vue?vue&type=style&index=0&id=6b93c02c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b93c02c",
  null
  
)

export default component.exports